"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClauseRules = void 0;
const context_js_1 = require("@/store/context.js");
// 同步改变
const getNewFormData = (list, value) => {
    const data = {};
    list.forEach((item) => {
        data[item.formKey] = value;
    });
    return data;
};
const useClauseRules = (rules, liability) => {
    const form = (0, context_js_1.useFormContext)();
    const { liabilityCode } = liability;
    const onChange = (value) => {
        if (!(rules === null || rules === void 0 ? void 0 : rules.length))
            return;
        rules.forEach((rule) => {
            const { type, targets } = rule;
            if (type === 'and') {
                if (targets.findIndex((target) => target.liabilityCode === liabilityCode) !== -1) {
                    const newData = getNewFormData(targets, value);
                    form.setFieldsValue(newData);
                }
            }
        });
    };
    return onChange;
};
exports.useClauseRules = useClauseRules;
